import { ElementDirection, TranslateLanguage } from '@fleet-beat/core';

export const translateLanguages: TranslateLanguage[] = [
  {
    code: 'en',
    name: 'English',
    elementDirection: ElementDirection.ltr,
    isDefault: true,
  },
  {
    code: 'ar',
    name: 'العربية',
    elementDirection: ElementDirection.rtl,
  },
];
